import { Loader } from "@caprikorn/dynamo-ui";
import type { FC } from "react";
import { generatePath, useParams } from "react-router-dom";

import { ErrorTemplate } from "@components/ErrorTemplate/ErrorTemplate";
import { Header } from "@components/Header/Header";
import { ArrowLeftMd } from "@icons";
import { ROUTES } from "@router/router.constants";
import { useGetCompanyStatement } from "@services/apiEcms/useGetCompanyStatement";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./Shield.module.css";
import type { URLShield } from "./Shield.types";
import { ShieldLegalIntro } from "./ShieldLegalIntro/ShieldLegalIntro";
import { ShieldStatusSwitcher } from "./ShieldStatusSwitcher/ShieldStatusSwitcher";

export const Shield: FC = () => {
  const { customerId = "" } = useParams<URLShield>();
  const { t } = useCustomTranslation("common");

  const { data, isFetching, isError, isSuccess } =
    useGetCompanyStatement(customerId);

  return (
    <>
      <Header
        breadcrumbPaths={[
          {
            pathName: t("button.back"),
            path: generatePath(ROUTES.PERIMETER_CONTRACTS_BY_CUSTOMER, {
              customerId,
            }),
            pathIcon: ArrowLeftMd,
          },
        ]}
      />
      <div className={classes.content}>
        {(isFetching || isError) && (isError ? <ErrorTemplate /> : <Loader />)}
        {!isFetching && isSuccess && (
          <>
            <ShieldLegalIntro />
            <ShieldStatusSwitcher data={data} />
          </>
        )}
      </div>
    </>
  );
};
